// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-details-container .form-nav-container {
  padding: 30px 0;
  font-family: "Proxima Nova", sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.team-details-container .form-nav-container .team-image {
  height: 200px;
  object-fit: cover;
  margin-left: 30px;
  border-radius: 10px;
}
.team-details-container .form-nav-container .team-info {
  margin-left: 30px;
}
.team-details-container .form-nav-container .team-info > p {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--secondary-color-1);
}
.team-details-container .form-nav-container .team-info > span {
  color: var(--secondary-color-1);
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
}
.team-details-container .form-nav-container .team-info .creator-info {
  display: flex;
}
.team-details-container .form-nav-container .team-info .creator-info img {
  height: 45px;
  width: 45px;
  object-fit: cover;
  border-radius: 10px;
}
.team-details-container .form-nav-container .team-info .creator-info > div > p {
  font-weight: 600;
  font-size: 18px;
  margin: 0;
  color: var(--secondary-color-1);
}
.team-details-container .form-nav-container .team-info .creator-info > div > span {
  font-weight: 400;
  font-size: 14px;
  color: #6C767C;
}
.team-details-container .form-nav-container .navigation {
  height: 300px;
}
.team-details-container .form-nav-container .navigation .header {
  font-size: 24px;
  font-weight: 700;
  color: var(--secondary-color-1);
  margin: 0;
  padding-left: 30px;
}
.team-details-container .form-nav-container .navigation ul.items {
  width: 300px;
}
.team-details-container .form-nav-container .navigation ul.items > li {
  height: 43px;
  flex: none;
  border-radius: 0px 10px 10px 0px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  transition: 0.3s ease-in-out;
  cursor: pointer;
  margin: 5px 0;
}
.team-details-container .form-nav-container .navigation ul.items > li.active {
  background-color: #F4F5F6;
}
.team-details-container .form-nav-container .navigation ul.items > li.active:hover {
  opacity: 1;
}
.team-details-container .form-nav-container .navigation ul.items > li.active div {
  opacity: 1;
}
.team-details-container .form-nav-container .navigation ul.items > li.active div p {
  font-weight: 700;
}
.team-details-container .form-nav-container .navigation ul.items > li:hover {
  background-color: var(--secondary-color-4);
}
.team-details-container .form-nav-container .navigation ul.items > li:hover div {
  opacity: 1;
}
.team-details-container .form-nav-container .navigation ul.items > li div {
  display: flex;
  align-items: center;
  opacity: 0.5;
  position: relative;
}
.team-details-container .form-nav-container .navigation ul.items > li div > div {
  width: 28px;
  display: flex;
  justify-content: center;
}
.team-details-container .form-nav-container .navigation ul.items > li div p {
  color: var(--secondary-color-1);
  margin-left: 15px;
  font-size: 16px;
  font-weight: 500;
}
.team-details-container .form-nav-container .navigation ul.items > li div.notif::before {
  content: "";
  position: absolute;
  left: -5px;
  top: 13px;
  height: 10px;
  width: 10px;
  background-color: rgb(235, 74, 74);
  border-radius: 10px;
  transition: 0.3s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/routes/TeamDetails/modules/FormNav/formNav.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,uCAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AACJ;AAAI;EACI,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AAER;AAAI;EACI,iBAAA;AAER;AADQ;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;AAGZ;AADQ;EACI,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAGZ;AADQ;EACI,aAAA;AAGZ;AAFY;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AAIhB;AADgB;EACI,gBAAA;EACA,eAAA;EACA,SAAA;EACA,+BAAA;AAGpB;AADgB;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAGpB;AAEI;EACI,aAAA;AAAR;AACQ;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;EACA,kBAAA;AACZ;AACQ;EACI,YAAA;AACZ;AAAY;EACI,YAAA;EACA,UAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,eAAA;EACA,aAAA;AAEhB;AADgB;EACI,yBAAA;AAGpB;AAFoB;EAAU,UAAA;AAK9B;AAJoB;EACI,UAAA;AAMxB;AALwB;EACI,gBAAA;AAO5B;AAHgB;EACI,0CAAA;AAKpB;AAJoB;EACI,UAAA;AAMxB;AAHgB;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAKpB;AAJoB;EACI,WAAA;EACA,aAAA;EACA,uBAAA;AAMxB;AAJoB;EACI,+BAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAMxB;AAJoB;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kCAAA;EACA,mBAAA;EACA,4BAAA;AAMxB","sourcesContent":[".team-details-container .form-nav-container {\r\n    padding: 30px 0;\r\n    font-family: 'Proxima Nova', sans-serif;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    height: 100%;\r\n    .team-image {\r\n        height: 200px;\r\n        object-fit: cover;\r\n        margin-left: 30px;\r\n        border-radius: 10px;\r\n    }\r\n    .team-info {\r\n        margin-left: 30px;\r\n        > p { \r\n            margin: 0; \r\n            font-size: 16px;\r\n            font-weight: 600;\r\n            color: var(--secondary-color-1);\r\n        }\r\n        > span {\r\n            color: var(--secondary-color-1);\r\n            font-weight: 400;\r\n            font-size: 16px;\r\n            line-height: 30px;\r\n        }\r\n        .creator-info {\r\n            display: flex;\r\n            img {\r\n                height: 45px;\r\n                width: 45px;\r\n                object-fit: cover;\r\n                border-radius: 10px;\r\n            }\r\n            > div {\r\n                > p {\r\n                    font-weight: 600;\r\n                    font-size: 18px;\r\n                    margin: 0;\r\n                    color: var(--secondary-color-1);\r\n                }\r\n                > span {\r\n                    font-weight: 400;\r\n                    font-size: 14px;\r\n                    color: #6C767C;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .navigation {\r\n        height: 300px;\r\n        .header {\r\n            font-size: 24px;\r\n            font-weight: 700;\r\n            color: var(--secondary-color-1);\r\n            margin: 0;\r\n            padding-left: 30px;\r\n        }\r\n        ul.items {\r\n            width: 300px;\r\n            > li {\r\n                height: 43px;\r\n                flex: none;\r\n                border-radius: 0px 10px 10px 0px;\r\n                display: flex;\r\n                align-items: center;\r\n                padding-left: 30px;\r\n                transition: .3s ease-in-out;\r\n                cursor: pointer;\r\n                margin: 5px 0;\r\n                &.active {\r\n                    background-color: #F4F5F6;\r\n                    &:hover { opacity: 1; }\r\n                    div {\r\n                        opacity: 1;\r\n                        p {\r\n                            font-weight: 700;\r\n                        }\r\n                    }\r\n                }\r\n                &:hover {\r\n                    background-color: var(--secondary-color-4);\r\n                    div { \r\n                        opacity: 1;\r\n                    }\r\n                }\r\n                div {\r\n                    display: flex;\r\n                    align-items: center;\r\n                    opacity: .5;\r\n                    position: relative;\r\n                    > div {\r\n                        width: 28px;\r\n                        display: flex;\r\n                        justify-content: center;\r\n                    }\r\n                    p {\r\n                        color: var(--secondary-color-1);\r\n                        margin-left: 15px;\r\n                        font-size: 16px;\r\n                        font-weight: 500;\r\n                    }\r\n                    &.notif::before {\r\n                        content: '';\r\n                        position: absolute;\r\n                        left: -5px;\r\n                        top: 13px;\r\n                        height: 10px;\r\n                        width: 10px;\r\n                        background-color: rgb(235, 74, 74);\r\n                        border-radius: 10px;\r\n                        transition: .3s ease-in-out;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
